import { Component, Input } from '@angular/core';

/**
 * Standard loading spinner for the app.
 *
 * Renders a medium (`nzSize="default"`) ng-zorro spinner centered both horizontally
 * and vertically in the available space.
 *
 * Two usage modes:
 * - Load / replace: toggle against content with `*ngIf`
 *     <gains-spinner *ngIf="isLoading"></gains-spinner>
 *     <div *ngIf="!isLoading">...content...</div>
 * - Overlay (mutations): wrap content so it is dimmed and blocked while busy
 *     <gains-spinner [spinning]="isSaving"><form>...</form></gains-spinner>
 */
@Component({
  selector: 'gains-spinner',
  standalone: false,
  templateUrl: './gains-spinner.component.html',
  styleUrl: './gains-spinner.component.scss'
})
export class GainsSpinnerComponent {
  /** Whether the spinner is active. Defaults to true so plain `*ngIf` usage needs no binding. */
  @Input() spinning = true;
  /** Optional text shown beneath the spinner. */
  @Input() tip?: string;
}
